import React from "react";
import "./BuyExclusiveGoods.css";
import phoneScreen3 from "../assets/images/phone-screen-3.png";
import phoneScreen4 from "../assets/images/phone-screen-4.png";

const BuyExclusiveGoods = () => {
  return (
    <section className="buy-exclusive-goods section">
      <div className="buy-exclusive-goods-container">

        <div className="buy-exclusive-goods-content">
          <div className="content-phones">
            <div className="phone-mockup">
              <div className="phone-frame">
                <img
                  src={phoneScreen4}
                  alt="Shopping Interface"
                  className="phone-screen"
                />
              </div>
            </div>
            <div className="phone-mockup mt-150px">
              <div className="phone-frame">
                <img
                  src={phoneScreen3}
                  alt="Product Details"
                  className="phone-screen"
                />
              </div>
            </div>
          </div>

          <div className="content-text">
            <h2 className="buy-exclusive-section-title">
              <span className="buy-excl">BUY Exclusive</span> <br />
              <span className="goods-with">GOODS with</span> <br />
              <span className="flow">Flow</span>
            </h2>
            <p className="subtitle">
              Browse a curated ecosystem of premium brands, creators, and luxury
              offerings. From rare collectibles to high-end goods, discover
              products that match your taste—all powered by $FLOW. Explore what
              the Flow community has built, or join the movement to access
              exclusive drops and real-time auction experiences.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuyExclusiveGoods;
